import React, { ReactElement, FCC } from 'react';
import { LayoutGrid } from '..';
import { IBigOrderedListProps } from './types';

import './BigOrderedList.scss';

export const BigOrderedList: FCC<IBigOrderedListProps> = (props) => {
  if (!props.children) {
    return null;
  }

  const generateBigListItems = () => {
    // filter out conditionally null children prior to map
    // to ensure big number in BigListItem child
    // is an expected value
    const validChildren = React.Children.toArray(props.children).filter((child: any) => child !== null);

    return React.Children.map(validChildren, (child: ReactElement<any>, index) => {
      return React.cloneElement(child, {
        itemNumber: index + 1,
      });
    });
  };

  return (
    <ol className="hlc-big-ordered-list" qa-id={props['qa-id']}>
      <LayoutGrid numberOfColumns={1} renderRowsAsSections={true}>
        {generateBigListItems()}
      </LayoutGrid>
    </ol>
  );
};

export default BigOrderedList;
